




































import { AccountOption } from "@/models/interface/cash-flow-report-mapping";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CashFlowAccountSelect extends Vue {
  @Prop({ required: true, type: Array })
  value!: string[];

  @Prop({ required: true, type: Array })
  options!: AccountOption[];

  @Prop({ default: "" })
  placeholder!: string;

  optionsMounted = false;

  get selectedOptions(): AccountOption[] {
    const selectedSet = new Set(this.value);
    return this.options.filter(opt => selectedSet.has(opt.id));
  }

  get unselectedOptions(): AccountOption[] {
    const selectedSet = new Set(this.value);
    return this.options.filter(opt => !selectedSet.has(opt.id));
  }

  onDropdownOpen(open: boolean): void {
    if (open && !this.optionsMounted) {
      this.optionsMounted = true;
    }
  }
}
